<div class="nav">
  <ul class="nav nav__tabs">
    <li
      *ngFor="let tab of tabs"
      (click)="selectTab(tab)"
      [class.selected]="tab.selected"
      [class.inactive]="!tab.active"
      [class.nav__tab--alert]="tab.alert">
      <span>
        @if (tab.alert) {
          <i class="agres-alert-triangle nav__alert-icon" aria-hidden="true"></i>
        }
        {{ tab.tabTitle }}
        @if (tab.alert && tab.alertLabel) {
          <span class="visually-hidden">{{ tab.alertLabel }}</span>
        }
      </span>
    </li>
  </ul>
  <ng-content></ng-content>
</div>
